module.exports = __webpack_public_path__ + "static/media/klm.d604a8d0.png";